import React from 'react'
import styled from 'styled-components'

interface BaseHeaderProps {
  left?: React.ReactNode
  center?: React.ReactNode
  right?: React.ReactNode
  sticky?: boolean
  border?: boolean
  className?: string
}

const HeaderContainer = styled.header<{ $sticky: boolean; $border: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1rem 1.25rem;
  background-color: ${({ theme }) => theme.colors.white || '#ffffff'};
  position: ${({ $sticky }) => ($sticky ? 'fixed' : 'relative')};
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;

  ${({ theme }) => theme.typography.variants['Button/Button-16-Semibold']}
`

const LeftSlot = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
`

const RightSlot = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
`

const BaseHeader: React.FC<BaseHeaderProps> = ({
  left,
  right,
  sticky = false,
  border = true,
  className,
}) => {
  return (
    <HeaderContainer $sticky={sticky} $border={border} className={className}>
      <LeftSlot>{left}</LeftSlot>
      {right && <RightSlot>{right}</RightSlot>}
    </HeaderContainer>
  )
}

export default BaseHeader
